import {
  IconBrain,
  IconCalendarEvent,
  IconMessageCircle2,
  IconSparkles,
} from "@tabler/icons-react";
import styles from "./GlobalJourney.module.css";

const STEPS = [
  {
    n: "01",
    icon: <IconCalendarEvent size={26} />,
    title: "Share Your Birth Details",
    body: "Date, time, and place of birth.",
  },
  {
    n: "02",
    icon: <IconBrain size={26} />,
    title: "Aura AI Reads Your Chart",
    body: "Planets, dasha, and key signals, analyzed in seconds.",
  },
  {
    n: "03",
    icon: <IconMessageCircle2 size={26} />,
    title: "Ask Anything",
    body: "Love, career, money, marriage, timing.",
  },
  {
    n: "04",
    icon: <IconSparkles size={26} />,
    title: "Get Instant Guidance",
    body: "Personal answers in plain language.",
  },
];

export default function GlobalSteps() {
  return (
    <section className={styles.stepsSection} aria-label="How Aura AI works">
      <div className={styles.how}>
        <h2 className={`${styles.h2} ${styles.howTitle}`}>How It Works</h2>
        <div className={styles.timeline}>
          <span className={styles.timelineLine} aria-hidden="true">
            <span className={styles.timelinePulse} />
          </span>
          {STEPS.map((s) => (
            <div className={styles.step} key={s.n}>
              <span className={styles.stepNode}>
                {s.icon}
                <span className={styles.stepNum}>{s.n}</span>
              </span>
              <h3 className={styles.stepTitle}>{s.title}</h3>
              <p className={styles.stepBody}>{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
